import React from 'react';
import { Route, Link } from 'react-router-dom';
import Management from './Management';
import Journal from './Journal';

const routes = [
  {
    id: 'management',
    dom: Management,
  },
  {
    id: 'journal',
    dom: Journal,
  }
];

interface Props {
  match: any;
}

const AssetModule = (props: Props) => {
  const { match } = props;
  return (
      <React.Fragment>
        {routes.map(({ id, dom }) => {
          return <Route exact key={id} path={`${match.url}/${id}`} component={dom} />;
        })}
      </React.Fragment>
    );
}

export default AssetModule